import React from 'react';
import { useSelector } from 'react-redux';

// Components
import {
  Typography,
  Table,
  Title,
  Button,
  Box,
  EmptyData,
  Margin,
  DownloadButton,
} from '@components';
import useDashboardExport from '@hooks/useDashboardExport';

// UTILS
import { setSingularPlural } from '@utils';

// Styles
import { DashWrapper, ViewMore, AchievementTable } from './Styled';

// Icons component
import IconArrowRight from '@icons/chevron-right.svg';

const Achievement = () => {
  const { achievement, loading } = useSelector(
    (state) => state.dashboard.tables
  );
  const { exportRanking } = useDashboardExport();
  const onLoading = Boolean(loading || loading === undefined);

  const buildTableCol = (content, alignRight = false) => (
    <td>
      <Typography size="1.4em" align={alignRight ? 'right' : 'left'}>
        {content}
      </Typography>
    </td>
  );

  const buildTableBody = (dataRows) => {
    return dataRows?.map((row, index) => {
      const moduleCount = setSingularPlural({
        count: row.student_has_done,
        word: 'Módulo',
      });
      return (
        <tr key={index}>
          {buildTableCol(index + 1)}
          {buildTableCol(row.fullname)}
          {buildTableCol(moduleCount, true)}
        </tr>
      );
    });
  };

  const renderTable = (
    <AchievementTable>
      <Table>
        <colgroup>
          <col span="1" style={{ width: '10%' }} />
          <col span="1" style={{ width: '60%' }} />
          <col span="1" style={{ width: '25%' }} />
        </colgroup>
        <tbody>{buildTableBody(achievement?.slice(0, 10))}</tbody>
      </Table>
      <Margin top={1} />
      <ViewMore>
        <DownloadButton
          onDownload={() => exportRanking({ limit: 10 })}
          variant="text"
        />
        <Button
          href="/home/conquistas"
          variant="text"
          rightIcon={<IconArrowRight />}
        >
          Ver mais
        </Button>
      </ViewMore>
    </AchievementTable>
  );

  return (
    <DashWrapper>
      <Title
        title="Conquistas"
        subtitle="Veja os top 10 colaboradores com conquistas de módulos concluídos, você também pode acessar a lista completa em ver mais."
      />
      <Box>
        {!achievement?.length && !onLoading ? <EmptyData /> : renderTable}
      </Box>
    </DashWrapper>
  );
};

export default Achievement;
export { Achievement };
